const data = {
  pageName: "Combo",
  services: {
    translations: {
      url: "combo/translations",
      params: {}
    },
    data: {
      url: "combo/data",
      params: {}
    }
  }
};

// Eligibilty Modal Emulator
// FOR DEVELOPMENT PURPOSES ONLY

window.getEligibilityResults = function(callback) {
  callback({
    eligibleConvergentPlans: [],
    eligibleFixedPlans: [
      "planfixdpgr360adsl",
      "planfixdpgr300adsl",
      "plantriplesports50",
      "plantriplesports30",
      "planfixdpgrdpgr200fiberdouble",
      "planfixdpgrdpgr100fibertripleentert",
      "planfixdpgrdpgr100fibertriplesp",
      "planfix5328"
    ],
    address: {
      "@class": "gr.vodafone.rest.dto.EligibilityAddressDTO",
      ak: "0449",
      buildingId: null,
      city: "Δ. ΗΛΙΟΥΠΟΛΗΣ",
      floor: null,
      latitude: null,
      location: "Ν. ΑΤΤΙΚΗΣ",
      longitude: null,
      settlement: null,
      streetName: "ΦΕΡΕΚΥΔΟΥ",
      streetNo: "1",
      zipCode: "16343"
    }
  });
};

exports.data = data;
